import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        {/* Company Section */}
        <div className="footer-section">
          <h4>About Us</h4>
          <p>
            The Brik is your solution for keeping essentials secure and organized.
            Perfect for busy individuals who value simplicity and efficiency.
          </p>
        </div>

        {/* Quick Links Section */}
        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/shop">Shop</a></li>
            <li><a href="/about">About</a></li>
            <li><a href="/exchange&delivery">Delivery & Exchange Policy</a></li>
            <li><a href="/tnc">Terms and Conditions</a></li>
            <li><a href="/privacy">Privacy Policy</a></li>
          </ul>
        </div>

        {/* Contact Section */}
        <div className="footer-section" id="contact-us">
          <h4>Contact Us</h4>
          <p>Email: <a href="mailto:asray@the-brik.com">asray@the-brik.com</a></p>
          <p>Phone: +1 (714) 787-9947</p>
          <p>Address: 119 Stanton Avenue, Ames, IA 50014</p>
        </div>

        {/* Social Media Section */}
        <div className="footer-section" style={{ textAlign: 'center' }}>
          <h4>Follow Us</h4>
          <div className="social-icons">
            <a href="https://www.facebook.com/people/The-Brik/61574215883635/"><i className="fab fa-facebook"></i></a>
            <a href="https://www.tiktok.com/@thebrik"><i className="fab fa-tiktok"></i></a>
            <a href="https://www.instagram.com/the.brik/"><i className="fab fa-instagram"></i></a>
            <a href="https://www.linkedin.com/company/103414107"><i className="fab fa-linkedin"></i></a>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <p>© 2025 The Brik. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;